import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";

import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import { HOST } from "routes/front/main/WebSocketContainer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import waitForItemCollection from "resources/img/waitForItemCollection.png";
import waitForItemCollectionSound from "resources/music/waitForItemCollectionSound.mp3";



const WaitingForProductsModal = NiceModal.create(props => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["80%", "50%"];
    const withCloseButton = false;
    const modal = useRef();
    const clickOutsideToClose = true;
    const title = t("");
    const buttonText = t("close");
    const audioRef = useRef();
    const [isMounted, setMounted] = useState(false);
    const [purchaseOrder, setPurchaseOrder] = useState([]);

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {


        if (props.data) {
            let data = {
                userId: props.data
            }
            requester.findAllByWaitingProducts(data, (result) => {
                setPurchaseOrder(result.data);
            })
        }

    }, [props.data])


    const onReceiveClick = (row) => {
        
        
        const extractedData = row.orderProducts.map(item => ({
            locationNo: item.locationNo,
            quantity: item.quantity,
            deviceId: item.deviceId
        }));
        
        
        // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
        const extractedValues = extractedData.map(item => {
            const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
            return [item.locationNo, item.quantity, deviceIdSuffix];
        });
        
        
        // 변환된 결과를 담을 JSON 객체 생성
        const resultObject = {};
        
        for (let i = 0; i < extractedValues.length; i++) {
            // 현재 요소 가져오기
            const itemArray = extractedValues[i];
        
            // productCode, quantity, deviceId 추출
            const productCode = itemArray[0];
            const quantity = itemArray[1];
            const deviceId = itemArray[2];
        
            // deviceId를 기준으로 객체에 추가
            if (!resultObject[deviceId]) {
                resultObject[deviceId] = [];
            }
        
            resultObject[deviceId].push({
                productCode: productCode,
                quantity: quantity
            });
        }
        
        // 객체를 배열로 변환
        const resultArray = Object.keys(resultObject).map(deviceId => ({
            deviceId: deviceId, // 'test' 접두사를 추가하여 deviceId 생성
            items: resultObject[deviceId]
        }));
        
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : '';
        
        let machineData = {
            userId: "",
            code: "order",
            roomId: props.storeCode,
            content: resultArray,
            deviceCode: deviceCode
        };
        
        
        requester.testOrder(machineData, (result) => {
            if (result.code === 0) {
                let productData = {
                    id: row.id,
                    totalAmount: row.totalAmount,
                    usedPoints: 0,
                    userId: props.data
                }
                
                requester.testChangeOrderStatus(productData, (result) => {
                    if (result.code === 0) {
                        let data = {
                            userId: props.data
                        }
                        requester.findAllByWaitingProducts(data, (result) => {
                            setPurchaseOrder(result.data);
                        })
                    }
                })
            }
        })
    }




    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
            onClose={props.onClose}
        >

            <VerticalFlex padding={"4vw"} gap={30}>

                <FlexChild height={"2px"} backgroundColor={"#eee"} />
                <FlexChild height={"max-content"}>
                    {/* <P font={"gmarketSansBold"} color={"#3E3E3E"} size={"3vw"}>먼저 구매한 고객님이 물건을 수령 중이에요.</P> */}
                    <P font={"gmarketSansBold"} color={"#3E3E3E"} size={"3vw"}>푸푸오더 1선결제 목록</P>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        {
                            purchaseOrder.length > 0
                                ?
                                purchaseOrder.map((row, index) => (
                                    <FlexChild height={"max-content"}>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <img src={row.orderProducts[0].productImg} width={"150px"} />
                                            </FlexChild>
                                            <FlexChild>
                                                <P>{row.orderProducts[0].productName} 외 {row.orderProducts.length}건</P>
                                            </FlexChild>
                                            <FlexChild justifyContent={"flex-end"}>
                                                <CustomButton text={"수령하기"} onClick={() => onReceiveClick(row)} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                ))
                                :
                                <P>정보가 없습니다</P>
                        }
                    </VerticalFlex>
                </FlexChild>


            </VerticalFlex>
        </ModalBase>
    );
});

export default WaitingForProductsModal;
